import t from 'tcomb';

const Payment_Type = t.enums.of('wepayyou paypal paypal_it paypal_cc qui_pago mysi skrill skrill_cc magento chebanca stripe stripe_sca satispay falkensteiner two_checkout custom'.split(' '));

module.exports = Payment_Type;



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Payment_Type.js
 **/